import {
  API_CONSOLIDACAO_DIARIA,
  API_KPIS,
  API_METRICAS_KPI,
  API_RELATORIOS_PRODUTIVIDADE,
} from '../api/apiConfig';
import { ConsolidacaoDiariaResumo, KPI, MetricaKPI, RelatorioProdutividade } from '../types/indicadores';
import { createCrudService } from './crudFactory';
import http from '../api/http';

export const kpiService = createCrudService<KPI>(API_KPIS);
export const metricasKpiService = createCrudService<MetricaKPI>(API_METRICAS_KPI);
export const relatoriosProdutividadeService =
  createCrudService<RelatorioProdutividade>(API_RELATORIOS_PRODUTIVIDADE);

export const consolidacaoDiariaService = {
  fetch: (params?: { data?: string }) =>
    http
      .get<ConsolidacaoDiariaResumo>(API_CONSOLIDACAO_DIARIA, { params })
      .then((res) => res.data),
};
